import JSEncrypt from "jsencrypt";

const PUBLIC_KEY_URL = `${process.env.BASE_URL || "/"}public_key.pem`;

let publicKeyPromise;

function loadPublicKey() {
  if (!publicKeyPromise) {
    publicKeyPromise = window
      .fetch(PUBLIC_KEY_URL, { cache: "force-cache" })
      .then((response) => {
        if (!response.ok) {
          throw new Error("密码加密公钥加载失败");
        }
        return response.text();
      })
      .then((publicKey) => {
        if (!publicKey.includes("BEGIN PUBLIC KEY")) {
          throw new Error("密码加密公钥格式错误");
        }
        return publicKey;
      })
      .catch((error) => {
        publicKeyPromise = null;
        throw error;
      });
  }
  return publicKeyPromise;
}

export async function encryptPassword(password) {
  const publicKey = await loadPublicKey();
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey);

  const encryptedPassword = encryptor.encrypt(password);
  if (!encryptedPassword) {
    throw new Error("密码加密失败");
  }
  return encryptedPassword;
}
